// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var grid = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("grid"),
      BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.rem(25 / 16)),
      BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.rem(25 / 16)),
      BsCssJs$PrezzeeRibbon.children([BsCssJs$PrezzeeRibbon.boxSizing("borderBox")])
    ]);

function twoPerRowOnTablet(amount) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                      NAME: "repeat",
                      VAL: [
                        {
                          NAME: "num",
                          VAL: amount
                        },
                        BsCssJs$PrezzeeRibbon.fr(1)
                      ]
                    }]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
                    BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                            NAME: "repeat",
                            VAL: [
                              {
                                NAME: "num",
                                VAL: 2
                              },
                              BsCssJs$PrezzeeRibbon.fr(1)
                            ]
                          }]),
                    BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.rem(20 / 16)),
                    BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.rem(20 / 16))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [
                    BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.fr(1)]),
                    BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.rem(0)),
                    BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.rem(1))
                  ])
            ]);
}

function threePerRowOnTablet(amount) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.gridTemplateColumns([{
                      NAME: "repeat",
                      VAL: [
                        {
                          NAME: "num",
                          VAL: amount
                        },
                        BsCssJs$PrezzeeRibbon.fr(1)
                      ]
                    }]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [
                    BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.rem(20 / 16)),
                    BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.rem(20 / 16))
                  ]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [
                    BsCssJs$PrezzeeRibbon.gridTemplateColumns([BsCssJs$PrezzeeRibbon.fr(1)]),
                    BsCssJs$PrezzeeRibbon.columnGap(BsCssJs$PrezzeeRibbon.rem(0)),
                    BsCssJs$PrezzeeRibbon.rowGap(BsCssJs$PrezzeeRibbon.rem(1))
                  ])
            ]);
}

var Styles = {
  grid: grid,
  twoPerRowOnTablet: twoPerRowOnTablet,
  threePerRowOnTablet: threePerRowOnTablet
};

function IconCard__Grid(props) {
  var amountOfTiles = props.amountOfTiles;
  var perRowOnTablet = props.perRowOnTablet;
  var perRowOnTablet$1 = perRowOnTablet !== undefined ? perRowOnTablet : /* Three */1;
  var amountPerRowOnDesktop = amountOfTiles > 4 ? 3 : amountOfTiles;
  var perRowStyle = perRowOnTablet$1 ? threePerRowOnTablet(amountPerRowOnDesktop) : twoPerRowOnTablet(amountPerRowOnDesktop);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    grid,
                    perRowStyle
                  ])
            });
}

var make = IconCard__Grid;

export {
  Styles ,
  make ,
}
/* grid Not a pure module */
